/** Pure logic for the admin KeyValueEditor (kept out of the component for testability). */

export interface KeyValuePairContent {
  key: string;
  value: string;
}

/** Shallow equality on string records; both-undefined counts as equal. */
export function recordsEqual(a?: Record<string, string>, b?: Record<string, string>): boolean {
  if (a === undefined || b === undefined) return a === b;
  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);
  return aKeys.length === bKeys.length && aKeys.every((k) => a[k] === b[k]);
}

/** Rows with a blank key are drafts and excluded; an all-draft list maps to undefined. */
export function pairsToRecord(pairs: KeyValuePairContent[]): Record<string, string> | undefined {
  const obj: Record<string, string> = {};
  pairs.forEach((p) => {
    if (p.key.trim()) {
      obj[p.key.trim()] = p.value.trim();
    }
  });
  return Object.keys(obj).length > 0 ? obj : undefined;
}
